
export default {
  components: {
  },
  props: {
    detail: {
      type: Object,
      default: {}
    },
    transfereeInfo: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
      id: '',
      dialogFormVisible: true,
      citytitle: ''
    };
  },
  computed: {
    district () {
      return this.detail.address.split(' ') && this.detail.address.split(' ')[2];
    },
    town () {
      return this.detail.address.split(' ') && this.detail.address.split(' ')[3];
    }
  },
  created () {
    // console.log(this.detail, 'this.detail', this.transfereeInfo);
    // console.log(this.detail.addressDetail.split(' ')[2], 'detail.addressDetail');
  },
  mounted () {
    this.$nextTick(function () {
      this.$refs.box.addEventListener('scroll', this.handleScroll);
    });
  },
  methods: {
    handleScroll () {
      const scrollTop = this.$refs.box.scrollTop; // 获取滑动距离
      if (scrollTop >= 1600) {
        this.$emit('enabledBtn');
      }
    }
  }
};
